import React from "react";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import { withStyles } from "material-ui";

import AddDappForm from "views/Forms/AddDappForm.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-react/views/sweetAlertStyle.jsx";

class AddDappAlert extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            alert: null,
        };
        this.hideAlert = this.hideAlert.bind(this);
        this.htmlAlert.bind(this);
    }

    componentDidMount() {
        if (this.props.show) {
            this.htmlAlert()
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.show) {
            this.htmlAlert();
        }
    }

    successAlert() {
        this.setState({
            alert: (
            <SweetAlert
            success
            style={{
                display: "block",
                marginTop: "-300px"
            }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
            }
            >
          Your application has been sent!
        </SweetAlert>
            )
        });
        setTimeout(this.hideAlert, 2000);
    }

    htmlAlert() {
        this.setState({
            alert: (
            <SweetAlert
            style={{
                display: "block",
                marginTop: "-300px"
            }}
            title="Add Dapp"
            onConfirm={() => this.hideAlert()}
            showConfirm={false}
            >
          <AddDappForm
            onSend={() => this.successAlert()}
            onCancel={() => this.hideAlert()}
            />
        </SweetAlert>
            )
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
        this.props.onClose();
    }

    render() {
        return this.state.alert;
    }
}

export default withStyles(sweetAlertStyle)(AddDappAlert);



// WEBPACK FOOTER //
// ./src/views/Components/AddDappAlert.jsx